<template>
    <v-container
        fluid
        grid-list-lg
    >
        <v-layout row>
            <v-flex xs12 xl6 offset-xl3>
                <v-card style="margin-bottom: 10px">
                    <v-card-title>Projekt</v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Projektnummer</strong></v-col>
                            <v-col cols="6">{{ building.buildingNumber }}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Name</strong></v-col>
                            <v-col cols="6">{{ building.name }}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Beschreibung</strong></v-col>
                            <v-col cols="6">{{ building.description }}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Land</strong></v-col>
                            <v-col cols="6" v-if="address != null">{{ address.country }}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Postleitzahl</strong></v-col>
                            <v-col cols="6" v-if="address != null">{{ address.postalCode }}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Stadt</strong></v-col>
                            <v-col cols="6" v-if="address != null">{{ address.city }}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Strasse</strong></v-col>
                            <v-col cols="6" v-if="address != null">{{ address.street }} {{ address.houseNumber }}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Zeit vor Ort</strong></v-col>
                            <v-col cols="6">{{ currentTime }}</v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-3"
                                    @click="editItem(building)"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>Ändern</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>

                <v-dialog
                    v-model="dialog"
                    max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Projekt ändern</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="editedItem.buildingNumber"
                                            label="Projektnummer">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="editedItem.name"
                                            label="Name">
                                        </v-text-field>
                                    </v-col>
                                  <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            v-model="editedItem.description"
                                            label="Beschreibung">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-autocomplete
                                            v-model="editedItemCountry"
                                            :items="countryList"
                                            label="Land"
                                            item-text="name"
                                            item-value="alpha"
                                        >
                                            <template v-slot:item="data">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        v-html="data.item.name"></v-list-item-title>
                                                    <v-list-item-subtitle
                                                        v-html="data.item.alpha"></v-list-item-subtitle>
                                                </v-list-item-content>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            v-model="editedItemCity"
                                            label="Stadt">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            v-model="editedItemPostalCode"
                                            label="Postleitzahl">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            v-model="editedItemStreet"
                                            label="Straße">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            v-model="editedItemHouseNumber"
                                            label="Nr">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                color="primary"
                                text
                                @click="close">
                                Abbrechen
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="updateBuilding">
                                Speichern
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-card style="margin-bottom: 10px">
                    <v-card-title>Status</v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Letzter Fehler</strong></v-col>
                            <v-col cols="6">
                                 <span
                                     v-if="state.lastFault !== '1970-01-01T00:00:00Z'">
                                        {{ state.lastFault | moment("L") }}
                                 </span>
                                <span v-else>
                                    -
                                </span>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Letzte Nachricht</strong></v-col>
                            <v-col cols="6">{{ state.lastMessage | moment("L") }}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Aktueller Status</strong></v-col>
                            <v-col cols="6">{{ state.state }}</v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" class="text-right"><strong>Verfügbarkeit</strong></v-col>
                            <v-col cols="6">~{{ availability != null ? Math.round(availability.available_percent) : 0 }}%</v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card style="margin-bottom: 10px">
                    <v-card-title>Router</v-card-title>
                    <v-card-text>
                        <v-text-field
                            label="API-Key - mindestens 10 Zeichen"
                            v-model="apiKey"
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="!apiKeyStorable"
                            @click="saveApiKey"
                            text
                            color="primary">
                            Anlegen
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <v-card
                    style="margin-bottom: 10px"
                    :loading="csvProcess"
                    :disabled="!csvPossible">
                    <v-card-title>Übersetzungen</v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col>
                                <v-file-input
                                    v-model="file"
                                    accept="text/csv"
                                    label="CSV-Upload"
                                    @change="uploadCsv"/>
                            </v-col>
                            <v-col>
                                <v-btn
                                    @click="saveApiKey"
                                    text
                                    color="primary">
                                    CSV-Download
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card
                    v-if="isAdmin"
                    style="margin-bottom: 10px">
                    <v-card-title>Projekt löschen</v-card-title>
                    <v-card-text>
                        <v-checkbox
                            v-model="checkbox"
                            label="Mir ist bewusst, dass das Projekt unwiderruflich gelöscht wird. Auch durch einen Systemadministrator können die Daten nicht wiederhergestellt werden.">
                        </v-checkbox>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            @click="deleteBuilding"
                            :disabled="!checkbox">
                            Projekt jetzt löschen
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
import countries from "@/util/lang-alpha-3";

export default {

    data: () => ({
        dialog: false,
        loading: true,
        checkbox: false,
        building: {},
        state: {},
        availability: {},
        countryList: [],
        address: {},
        excelLoading: false,
        excelData: '',
        currentItem: {},
        changeDialog: false,
        csvProcess: false,
        apiKey: '',
        device: null,
        file: null,
        isAdmin: false,
        editedItem: {
            uuid: '',
            buildingNumber: '',
            name: '',
            description: '',
            address: {
                city: '',
                houseNumber: '',
                country: '',
                postalCode: '',
                street: '',
            }
        },
        defaultItem: {
            buildingNumber: '',
            name: '',
            description: '',
            address: {
                city: '',
                houseNumber: '',
                country: '',
                postalCode: '',
                street: '',
            }
        }
    }),
    watch: {
        dialog(val) {
            val || this.close()
        }
    },
    computed: {
        currentTime() {
            return this.address ? moment().utcOffset(this.address.utcOffset / 60).locale('de').format('lll') : "--";
        },
        csvPossible() {
            return this.device !== null
        },
        apiKeyStorable() {
            return this.apiKey.trim().length > 9
        },
        editedItemCountry: {
            get: function() { return this.editedItem.address != null ? this.editedItem.address.country : "" },
            set: function(value) {
                this.editedItem.address.country = value;
            }
        },
        editedItemCity: {
            get: function() { return this.editedItem.address != null ? this.editedItem.address.city : "" },
            set: function(value) {
                this.editedItem.address.city = value;
            }
        },
        editedItemPostalCode: {
            get: function() { return this.editedItem.address != null ? this.editedItem.address.postalCode : "" },
            set: function(value) {
                if (this.editedItem.address == null) {
                    this.editedItem.address = {};
                }
                this.editedItem.address.postalCode = value;
            }
        },
        editedItemStreet: {
            get: function() { return this.editedItem.address != null ? this.editedItem.address.street : "" },
            set: function(value) {
                if (this.editedItem.address == null) {
                    this.editedItem.address = {};
                }
                this.editedItem.address.street = value;
            }
        },
        editedItemHouseNumber: {
            get: function() { return this.editedItem.address != null ? this.editedItem.address.houseNumber : "" },
            set: function(value) {
                if (this.editedItem.address == null) {
                    this.editedItem.address = {};
                }
                this.editedItem.address.houseNumber = value;
            }
        }
    },
    mounted() {
        this.countryList = countries.items;
        this.loadDevice();
        this.loadBuilding();
        this.loadState();
        this.loadAvailability();
        this.checkIsAdmin()
    },
    methods: {
        loadDevice() {
            axios.get('/telematics/api/device/?projectUuid=' + this.$route.params.buildingUuid)
                .then(response => {
                    if (response.data.length > 0) {
                        this.device = response.data[0];
                    }
                });
        },
        checkIsAdmin() {
            axios.get('/user/api/user/' + this.$keycloak.subject + '/isAdmin/')
                .then(response => {
                    this.isAdmin = response.data.admin;
                })
        },
        editItem(item) {
            this.editedItem = Object.assign({}, item);
            if(this.editedItem.address == null){
              this.editedItem.address = {
                    city: '',
                    houseNumber: '',
                    country: '',
                    postalCode: '',
                    street: '',
              }
            }
            this.dialog = true
        },
        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
            }, 300)
        },
        loadBuilding() {
            axios.get('/address-contact/api/building/' + this.$route.params.buildingUuid + '/')
                .then(response => {
                    this.building = response.data;
                    this.address = response.data.address
                });
        },
        updateBuilding() {
          this.$store.dispatch('updateBuilding', this.editedItem);
          this.building.name = this.editedItem.name;
          this.building.description = this.editedItem.description;
          this.address = this.editedItem.address
          this.close();
        },
        deleteBuilding() {
            axios.delete('/address-contact/api/building/' + this.$route.params.buildingUuid + '/')
                .then(() => {
                    this.$router.back();
                });
        },
        loadState() {
            axios.get('/current-state/api/bvh/')
                .then(response => {
                    response.data.forEach((i) => {
                        if (i.buildingUuid === this.$route.params.buildingUuid) {
                            this.state = i
                        }
                    })
                });
        },
        loadAvailability() {
            axios.post('/legacy-m2m/api/availability/', [this.$route.params.buildingUuid])
                .then(response => {
                    this.availability = response.data[this.$route.params.buildingUuid];
            });
        },
        downloadCsv() {
            if (this.device !== {}) {
                this.csvProcess = true;
                axios({
                    url: '/telematics/api/csv/' + this.device.uuid + '/',
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Texte_' + this.building.buildingNumber + '.csv');
                    document.body.appendChild(link);
                    link.click();
                    this.csvProcess = false
                })
            }
        },
        uploadCsv() {
            if (this.csvPossible) {
                this.csvProcess = true;
                const formData = new FormData();
                formData.append("file", this.file);
                axios.post('/telematics/api/csv/', formData)
                    .then(() => {
                        this.csvProcess = false
                    })
            }
        },
        saveApiKey() {
            if (this.device !== {}) {
                this.device.deviceKey = this.deviceKey;
                axios.put('/telematics/api/device/' + this.device.uuid + '/', this.device)
                    .then(response => {
                        this.device = response.data
                    })
            } else {
                this.device = {
                    name: 'EWON ' + this.building.buildingNumber,
                    projectUuid: this.building.uuid,
                    deviceKey: this.deviceKey
                };
                axios.post('/telematics/api/device/', this.device)
                    .then(response => {
                        this.device = response.data
                    })
            }
        }
    }
}
</script>
